import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _styled from '@emotion/styled-base';
import React__default from 'react';
import { borderDivider } from '../theme/theme.js';
import cx from 'classnames';

var _excluded = ["className"];

var Divider = /*#__PURE__*/_styled("div", {
  target: "e13ld7mx0"
})("margin:", function (_ref) {
  var vertical = _ref.vertical;
  return vertical ? "0 0.5rem" : "0.5rem 0";
}, ";border-top:1px solid ", borderDivider, ";border-right:1px solid ", borderDivider, ";");

var DividerV2 = /*#__PURE__*/React__default.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React__default.createElement(Divider, _extends({
    className: cx("vds-divider", className),
    ref: ref
  }, props));
});

export { DividerV2 };
//# sourceMappingURL=divider-v2.js.map
